import { useEffect } from 'react';

const useScrollToTopOnStateChange = (state: unknown) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [state]);
};

export default useScrollToTopOnStateChange;
